<ng-template #multiLangContent>
  <div
    data-automation="explorer-multiple-greetings-audio-files-popover"
    class="p-2 min-width-100 d-flex flex-column gap-2"
  >
    <div class="d-flex align-items-start justify-content-between">
      <div class="d-flex flex-column gap-2">
        <span class="fw-bold d-flex justify-content-center">
          {{
            'tkey;migrations.cisco.auto_attendants_report.explorer.destinations.call_handler_audio_files_popover_title'
              | translate
          }}
        </span>
        <span class="text-muted small">
          {{
            'tkey;migrations.cisco.auto_attendants_report.explorer.destinations.call_handler_audio_files_popover_description'
              | translate
          }}
        </span>
      </div>
    </div>

    <div data-automation="greeting-multi-audio-language-labels" class="list-group">
      @for (url of audioFileUrls(); track url) {
        <div class="list-group-item d-flex align-items-center justify-content-between">
          <div data-automation="greeting-audio-language-label" class="d-flex flex-column">
            <strong>{{ extractLanguageDisplay(url) }}</strong>
          </div>
          <div class="d-flex align-items-center gap-2">
            <button
              type="button"
              class="btn btn-border btn-link p-0"
              [class.text-muted]="mediaDisabled()"
              [class.disabled]="mediaDisabled()"
              aria-label="Play greeting"
              data-automation="explorer-popover-greeting-action-play"
              [ngbTooltip]="
                !mediaDisabled()
                  ? ('tkey;migrations.cisco.auto_attendants.detailed_view.greetings.audio.play' | translate)
                  : ('tkey;migrations.cisco.auto_attendants.detailed_view.greetings.audio_type.disabled' | translate)
              "
              triggers="hover"
              (click)="
                this.activeGreetingAudioUrl() === url
                  ? stopPlayingCurrentAudioGreeting()
                  : onRowAudioPlayClick($event, url)
              "
            >
              @if (this.activeGreetingAudioLoadingUrl() === url) {
                <i [ngClass]="[ziroIcons.LOADING, 'explorer-node__loading-icon']"></i>
              } @else if (this.activeGreetingAudioUrl() === url) {
                <i [ngClass]="[ziroIcons.STOP, 'explorer-node__base-icon']"></i>
              } @else {
                <i [ngClass]="[ziroIcons.PLAY, 'explorer-node__base-icon']"></i>
              }
            </button>
            <button
              class="btn btn-border btn-link p-0"
              [class.text-muted]="mediaDisabled()"
              [class.disabled]="mediaDisabled()"
              [attr.aria-disabled]="mediaDisabled()"
              aria-label="Download greeting"
              data-automation="explorer-popover-greeting-action-play"
              [ngbTooltip]="
                !mediaDisabled()
                  ? ('tkey;migrations.cisco.auto_attendants.detailed_view.greetings.audio.download' | translate)
                  : ('tkey;migrations.cisco.auto_attendants.detailed_view.greetings.audio_type.disabled' | translate)
              "
              triggers="hover"
              (click)="onRowAudioDownloadClick($event, url)"
            >
              @if (this.activeGreetingAudioDownloadUrl() === url) {
                <i [ngClass]="[ziroIcons.LOADING, 'explorer-node__loading-icon']"></i>
              } @else {
                <i [ngClass]="[ziroIcons.DOWNLOAD_SMALL, 'explorer-node__base-icon']"></i>
              }
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<div
  class="explorer-node"
  data-automation="explorer-node-child"
  [ngClass]="{
    'explorer-node--disabled': disabled(),
    'explorer-node--previously-viewed': isPreviouslyViewedNode(),
  }"
>
  <div class="explorer-node__title">
    <div class="d-flex align-items-center justify-content-between">
      <span
        [ngbTooltip]="previouslyViewedTooltip() | translate"
        [disableTooltip]="!isPreviouslyViewedNode()"
        data-automation="explorer-node-title"
      >
        <strong>{{ title() | translate }}</strong>
        @if (isPreviouslyViewedNode()) {
          <i [class]="ZiroIcons.TOOLTIP + ' ms-1'"></i>
        }
      </span>

      @if (!!audioFileUrls()) {
        <div
          class="d-flex align-items-center gap-2"
          [ngbPopover]="multiLangContent"
          triggers="manual"
          #multipleAudioFilesPopover="ngbPopover"
          container="body"
          [placement]="'bottom'"
          [autoClose]="'outside'"
        >
          <button
            type="button"
            class="btn btn-border btn-link p-0"
            [class.text-muted]="mediaDisabled()"
            [class.disabled]="mediaDisabled()"
            [disabled]="mediaDisabled()"
            aria-label="Play greeting"
            data-automation="explorer-greeting-action-play"
            [ngbTooltip]="
              !mediaDisabled()
                ? ('tkey;migrations.cisco.auto_attendants.detailed_view.greetings.audio.play' | translate)
                : ('tkey;migrations.cisco.auto_attendants.detailed_view.greetings.audio_type.disabled' | translate)
            "
            triggers="hover"
            (click)="
              hasMultipleAudioFiles()
                ? multipleAudioFilesPopover.open()
                : this.isCurrentAudioPlaying()
                  ? stopPlayingCurrentAudioGreeting()
                  : onSingleAudioNodePlayClick($event)
            "
          >
            @if (!hasMultipleAudioFiles() && isCurrentAudioLoading()) {
              <i [ngClass]="[ziroIcons.LOADING, 'explorer-node__loading-icon']"></i>
            } @else if (!hasMultipleAudioFiles() && this.isCurrentAudioPlaying()) {
              <i [ngClass]="[ziroIcons.STOP, 'explorer-node__base-icon']"></i>
            } @else {
              <i [ngClass]="[ziroIcons.PLAY, 'explorer-node__base-icon']"></i>
            }
          </button>
          <button
            class="btn btn-border btn-link p-0"
            [class.text-muted]="mediaDisabled()"
            [class.disabled]="mediaDisabled()"
            [disabled]="mediaDisabled()"
            [attr.aria-disabled]="mediaDisabled()"
            aria-label="Download greeting"
            data-automation="explorer-greeting-action-download"
            [ngbTooltip]="
              !mediaDisabled()
                ? ('tkey;migrations.cisco.auto_attendants.detailed_view.greetings.audio.download' | translate)
                : ('tkey;migrations.cisco.auto_attendants.detailed_view.greetings.audio_type.disabled' | translate)
            "
            triggers="hover"
            (click)="hasMultipleAudioFiles() ? multipleAudioFilesPopover.open() : onSingleAudioDownloadClick($event)"
          >
            @if (hasMultipleAudioFiles() || !isCurrentAudioDownloading()) {
              <i [ngClass]="[ziroIcons.DOWNLOAD_SMALL, 'explorer-node__base-icon']"></i>
            } @else {
              <i [ngClass]="[ziroIcons.LOADING, 'explorer-node__loading-icon']"></i>
            }
          </button>
        </div>
      }
    </div>
  </div>

  @if (!disabled()) {
    <div class="explorer-node__info">
      @if (warnings()) {
        <div class="explorer-node__info__warnings" data-automation="explorer-node-warnings">
          @for (warning of warnings(); track $index) {
            <span class="d-flex align-items-sm-start gap-2">
              <i class="explorer-node__info__warning-icon" [ngClass]="ziroIcons.WARNING_TRIANGLE"></i>
              <span
                class="explorer-node__info__warning-text"
                [innerHTML]="warning | escapeHtml"
                data-automation="explorer-node-warning-text"
              ></span>
            </span>
          }
        </div>
      }
      <div class="d-flex">
        @if (previousLink()) {
          <div class="explorer-node__info__button--start">
            <button
              class="btn btn-border btn-outline-primary"
              (click)="linkClicked.emit({ subchartId: previousLink(), direction: 'previous' })"
              data-automation="explorer-node-previous-link"
            >
              <i [class]="ZiroIcons.PREVIOUS"></i>
            </button>
          </div>
        }
        @if (icon()) {
          <div class="explorer-node__info__icon">
            <i [class]="icon() + ' h-100'" data-automation="explorer-node-icon"></i>
          </div>
        }
        <div class="explorer-node__info--centered">
          <div data-automation="explorer-node-label">
            <strong>{{ label() | translate }}</strong>
          </div>
          @if (sublabel()) {
            <div
              class="explorer-node__info__sublabel"
              data-automation="explorer-node-sublabel"
              [innerHTML]="sublabel() | escapeHtml"
            ></div>
          }
        </div>
        @if (nextLink()) {
          <div class="explorer-node__info__button--end">
            <button
              class="btn btn-border btn-outline-primary"
              (click)="linkClicked.emit({ subchartId: nextLink(), direction: 'next' })"
              data-automation="explorer-node-next-link"
            >
              <i [class]="ZiroIcons.NEXT"></i>
            </button>
          </div>
        }
      </div>
    </div>
  }
</div>
